var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 20 22",
    style: {
      enableBackground: "new 0 0 20 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2,16.6c-0.4-0.4-0.4-0.9-0.1-1.3l0.1-0.1l4.3-4.3l-4.3-4.3c-0.4-0.4-0.4-0.9-0.1-1.3l0.1-0.1 c0.4-0.4,0.9-0.4,1.3-0.1l0.1,0.1l5,5c0.4,0.4,0.4,0.9,0.1,1.3l-0.1,0.1l-5,5C14.3,17,13.6,17,13.2,16.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9,9.9c0.6,0,1,0.4,1,1c0,0.5-0.4,0.9-0.9,1l-0.1,0h-10c-0.6,0-1-0.4-1-1c0-0.5,0.4-0.9,0.9-1 l0.1,0H17.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1,0c0.5,0,0.9,0.4,1,0.9L2,1v19.2c0,0.6-0.4,1-1,1c-0.5,0-0.9-0.4-1-0.9l0-0.1V1C0,0.4,0.4,0,1,0z "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.d79e81abff75ff8caff36bbfbf8f42ee.svg";
export { ForwardRef as ReactComponent };